import { buildBaseEventData } from './commonAnalytics';
import { Utils } from './sendAnalyticsEvent';

export const trackHowItWorks = () => {
  const clickEvent = buildBaseEventData('overlay', 'carpet installation - how it works');
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackStoreLocationZipSearch = () => {
  const clickEvent = buildBaseEventData('button submission', 'find a store');
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackStoreLocationStoreLocationSet = () => {
  const clickEvent = buildBaseEventData('button submission', 'make this my store');
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackViewMoreStoresLoad = () => {
  const clickEvent = buildBaseEventData('overlay', 'view more stores');
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackViewMoreStoresZipSearch = () => {
  const clickEvent = buildBaseEventData('button submission', 'find a store');
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackViewMoreStoresStoreLocationSet = () => {
  const clickEvent = buildBaseEventData('button submission', 'make this my store');
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackMeasuringTips = () => {
  const clickEvent = buildBaseEventData('overlay', 'carpet installation - measuring tips');
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackEnterRoomsAddRoom = (id, area) => {
  const clickEvent = buildBaseEventData('interaction', 'configurator click');
  clickEvent.content = {
    module: [{
      name: 'carpet configurator',
      feature: `add room:${id}`,
      type: `sqft:${area}`,
    }],
  };
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackEnterRoomsEditRoom = (id, area) => {
  const clickEvent = buildBaseEventData('interaction', 'configurator click');
  clickEvent.content = {
    module: [{
      name: 'carpet configurator',
      feature: `edit room:${id}`,
      type: `sqft:${area}`,
    }],
  };
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackEnterRoomsRemoveRoom = (id, area) => {
  const clickEvent = buildBaseEventData('interaction', 'configurator click');
  clickEvent.content = {
    module: [{
      name: 'carpet configurator',
      feature: `remove room:${id}`,
      type: `sqft:${area}`,
    }],
  };
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackStaircaseYesNo = (yes) => {
  const clickEvent = buildBaseEventData('interaction', 'configurator click');
  clickEvent.content = {
    module: [{
      name: 'carpet configurator',
      feature: 'staircase',
      type: `${yes}`,
    }],
  };
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackStaircaseNumber = (number) => {
  const clickEvent = buildBaseEventData('interaction', 'configurator click');
  clickEvent.content = {
    module: [{
      name: 'carpet configurator',
      feature: 'staircase',
      type: `steps:${number}`,
    }],
  };
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackFilterChange = (filters, sort) => {
  const clickEvent = buildBaseEventData('browse', 'filter by');
  clickEvent.displayAttributes = {
    productsAvailability: 'all products',
    sortBy: sort,
    viewType: 'grid',
  };
  clickEvent.filter = [];
  Object.values(filters).forEach((filter) => {
    if (filter !== null && filter !== '' && filter[filter.type.toLowerCase()] !== '') {
      const type = filter.type.toLowerCase();
      const values = filter[type].split('|');
      if (values) {
        values.forEach((value) => {
          clickEvent.filter.push({
            position: type === 'brands' || type === 'warranties' ? 'left drawer' : 'visual filter',
            type,
            value,
          });
        });
      }
    }
  });
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackSortChange = (sort) => {
  const clickEvent = buildBaseEventData('browse', 'sort by');
  clickEvent.displayAttributes = {
    productsAvailability: 'all products',
    sortBy: sort,
    viewType: 'grid',
  };
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackCarpetSelectionQuickView = (omsid) => {
  const clickEvent = buildBaseEventData('interaction', 'configurator click');
  clickEvent.content = {
    module: [{
      name: 'carpet configurator',
      feature: 'quick view',
      type: `${omsid}`,
    }],
  };
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackCarpetSelectionBuyASample = (sku, index, price) => {
  const clickEvent = buildBaseEventData('stash', 'cart add location');
  clickEvent.eventMode = 'stash';
  clickEvent.stash = {
    pageType: 'tool:carpet installation:configurator',
    sharedSection: '',
    section: 'grid',
    component: 'inline pod',
    target: 'atc',
    item: [{
      index,
      productId: sku,
    }],
  };
  Utils.sendAnalyticsEvent(clickEvent);

  const atcEvent = buildBaseEventData('overlay', 'cart add');
  atcEvent.item = [{
    productInfo: {
      sku,
    },
    quantity: '1',
    price: {
      basePrice: price,
    },
    fulfillment: {
      method: 'sth',
    },
  }];
  Utils.sendAnalyticsEvent(atcEvent);
};

export const trackCarpetSelectionLoadMore = () => {
  const clickEvent = buildBaseEventData('browse', 'pagination');
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackPaddingSelection = (id) => {
  const clickEvent = buildBaseEventData('interaction', 'configurator click');
  clickEvent.content = {
    module: [{
      name: 'carpet configurator',
      feature: 'padding',
      type: `${id}`,
    }],
  };
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackNavigationLinkTracking = (location, linkText) => {
  const clickEvent = buildBaseEventData('interaction', 'pip sub-content');
  clickEvent.subContent = {
    section: location,
    component: 'nav-item',
    target: linkText,
  };
  Utils.sendAnalyticsEvent(clickEvent);
};

export const trackSaveAndContinue = (carpetSku) => {
  const clickEvent = buildBaseEventData('installation services and repair', 'form start');
  clickEvent.form = {
    formType: 'installation services and repair',
    formName: 'carpet installation',
  };
  Utils.sendAnalyticsEvent(clickEvent);

  const designAddEvent = buildBaseEventData('button submission', 'design add product');
  designAddEvent.item = [{
    productInfo: {
      sku: `${carpetSku}`,
    },
  }];
  Utils.sendAnalyticsEvent(designAddEvent);
};

export const trackUpdateDesign = (carpetSku) => {
  const clickEvent = buildBaseEventData('button submission', 'design item config update');
  clickEvent.item = [{
    productInfo: {
      sku: `${carpetSku}`,
    },
  }];
  Utils.sendAnalyticsEvent(clickEvent);
};

/*

export const track = () => {
  const clickEvent = buildBaseEventData('', '');
  Utils.sendAnalyticsEvent(clickEvent);
};
*/
